"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.network = void 0;
var helper_1 = require("./helper");
var network_manager_1 = __importDefault(require("./network-manager"));
var instance = network_manager_1.default.create({
    autoRun: false,
});
// 创建全局单例
exports.network = helper_1.createSingleton(instance);
//# sourceMappingURL=index.js.map